module.exports = __webpack_public_path__ + "static/barcelona_code_school_campus_-6-81aedb8616b7914e0223105933de6adc.jpg";